import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { IconPanel } from '../../../../icon-panel/icon-panel';

export const OnDemandNotAvailablePanel = () => {
  const { t } = useTranslation();

  return (
    <Component>
      <IconPanel
        header={{ icon: { icon: ['fad', 'rocket'], opacity: '50%', size: '8x' } }}
        responsiveness={{ compressed: false }}
      >
        {{
          title: t('onDemand.title', { ns: 'components' }),
          info: t('onDemand.notAvailableInfo', { ns: 'components' }),
        }}
      </IconPanel>
    </Component>
  );
};

const Component = styled.div`
  height: 100%;
  display: flex;
  padding: 1em;
`;
